module.exports = __webpack_public_path__ + "static/media/52_tn.192f45c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/52_tn.jpg
// module id = 360
// module chunks = 0